import { render, staticRenderFns } from "./FiduciarySelection.vue?vue&type=template&id=1ccea412&scoped=true&"
import script from "./FiduciarySelection.vue?vue&type=script&lang=js&"
export * from "./FiduciarySelection.vue?vue&type=script&lang=js&"
import style0 from "./FiduciarySelection.vue?vue&type=style&index=0&id=1ccea412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccea412",
  null
  
)

export default component.exports